import React from 'react';

export const SSOIcons = {
  google: (
    <svg className="sso-icon" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4" />
      <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853" />
      <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05" />
      <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335" />
    </svg>
  ),
  microsoft: (
    <svg className="sso-icon" viewBox="0 0 18 18">
      <rect width="8" height="8" fill="#F25022" />
      <rect x="10" width="8" height="8" fill="#7FBA00" />
      <rect y="10" width="8" height="8" fill="#00A4EF" />
      <rect x="10" y="10" width="8" height="8" fill="#FFB900" />
    </svg>
  ),
  github: (
    <svg className="sso-icon" viewBox="0 0 18 18" fill="currentColor">
      <path d="M9 0a9 9 0 0 0-2.844 17.54c.45.082.617-.195.617-.434 0-.214-.008-.78-.012-1.532-2.503.544-3.032-1.207-3.032-1.207-.41-1.04-1-1.317-1-1.317-.817-.559.062-.547.062-.547.904.063 1.379.928 1.379.928.803 1.376 2.108.979 2.622.748.082-.582.314-.979.572-1.204-2-.227-4.103-1-4.103-4.45 0-.983.351-1.787.927-2.417-.093-.227-.402-1.143.088-2.382 0 0 .756-.242 2.475.923A8.63 8.63 0 0 1 9 4.31c.762.003 1.53.103 2.247.302 1.717-1.165 2.472-.923 2.472-.923.49 1.24.182 2.155.089 2.382.577.63.926 1.434.926 2.417 0 3.46-2.106 4.22-4.112 4.443.323.279.612.829.612 1.671 0 1.207-.011 2.18-.011 2.476 0 .242.163.522.62.434A9 9 0 0 0 9 0z" />
    </svg>
  ),
};

export const AuthMarketingPanel = ({ variant = 'testimonial' }) => (
  <aside className="auth-marketing-panel">
    <div className="auth-mkt-header">
      <span className="pill"><span className="dot"></span>Early access · launching 2027</span>
    </div>
    <div>
      <h2 className="auth-mkt-headline">The translation dashboard your team <em>actually wants to open.</em></h2>
    </div>
    {variant === 'testimonial' ? (
      <div className="auth-mkt-quote">
        <p className="auth-mkt-quote-text">"I couldn't find a platform that handled our IDML files without breaking the whole workflow — so I'm building one that does."</p>
        <div className="auth-mkt-quote-author">
          <div className="auth-mkt-quote-avatar">CR</div>
          <div>
            <div className="auth-mkt-quote-name">Chris Rush</div>
            <div className="auth-mkt-quote-role">Founder · Rush Studio</div>
          </div>
        </div>
      </div>
    ) : (
      <div className="auth-mkt-features">
        {[
          ['100+ languages, day one', 'Translation memory and glossaries included from your first project.'],
          ['14-day risk-free trial', "Cancel anytime. We'll even help migrate your existing TM."],
          ['SOC 2 + GDPR ready', 'Enterprise-grade security on every plan. SSO available.'],
        ].map(([title, body]) => (
          <div className="auth-mkt-feature" key={title}>
            <span className="auth-mkt-feature-icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l3 3 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </span>
            <div className="auth-mkt-feature-text"><b>{title}</b>{body}</div>
          </div>
        ))}
      </div>
    )}
    <div className="auth-mkt-stats">
      <div className="auth-mkt-stat"><div className="auth-mkt-stat-num">2024</div><div className="auth-mkt-stat-label">founded</div></div>
      <div className="auth-mkt-stat"><div className="auth-mkt-stat-num">100+</div><div className="auth-mkt-stat-label">languages</div></div>
      <div className="auth-mkt-stat"><div className="auth-mkt-stat-num">2027</div><div className="auth-mkt-stat-label">launching</div></div>
    </div>
  </aside>
);
